import ChatArea from './chatArea'

export default ChatArea;
